import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setIsShowingUserSheet,
  selectIsShowingUserSheet,
  selectGoToResetPassword,
  selectGoToUserDetails,
  selectGoToConfigureNotifications,
} from 'store/appSlice';
import { styled } from '@mui/material/styles';
import MUIDrawer from '@mui/material/Drawer';
import Paper from '@mui/material/Paper';
import PropTypes from 'prop-types';
import PartnerMain from './PartnerMain';
import Slide from '@mui/material/Slide';
import Stack from '@mui/material/Stack';
import UserDetails from './UserDetails';
import UserMain from './UserMain';
import UserResetPassword from './UserResetPassword';
import ConfigureNotifications from './ConfigureNotifications';

export default function UserDrawer({ isPartner = false }) {
  const isShowingUserSheet = useSelector(selectIsShowingUserSheet);
  const goToResetPassword = useSelector(selectGoToResetPassword);
  const goToUserDetails = useSelector(selectGoToUserDetails);
  const goToConfigureNotifications = useSelector(
    selectGoToConfigureNotifications
  );
  const dispatch = useDispatch();
  const userDrawerRef = useRef(null);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    dispatch(setIsShowingUserSheet({ showing: open }));
  };

  return (
    <Drawer
      anchor="right"
      open={isShowingUserSheet}
      onClose={toggleDrawer(false)}
    >
      <Stack
        ref={userDrawerRef}
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {isPartner && <PartnerMain />}
        {!isPartner && <UserMain />}
        {/* Reset Password Page */}
        <Slide
          direction="up"
          in={goToResetPassword}
          container={userDrawerRef.current}
          mountOnEnter
          unmountOnExit
        >
          <SlidePaper>
            <UserResetPassword isPartner={isPartner} />
          </SlidePaper>
        </Slide>
        {/* User Details Page */}
        <Slide
          direction="up"
          in={goToUserDetails}
          container={userDrawerRef.current}
          mountOnEnter
          unmountOnExit
        >
          <SlidePaper>
            <UserDetails />
          </SlidePaper>
        </Slide>
        {/* Configure Notifications Page */}
        <Slide
          direction="up"
          in={goToConfigureNotifications}
          container={userDrawerRef.current}
          mountOnEnter
          unmountOnExit
        >
          <SlidePaper>
            <ConfigureNotifications />
          </SlidePaper>
        </Slide>
      </Stack>
    </Drawer>
  );
}

UserDrawer.propTypes = {
  isPartner: PropTypes.bool,
};

//##################################################################
// ### STYLED COMPONENTS
//##################################################################

const Drawer = styled((props) => (
  <MUIDrawer anchor="right" variant="temporary" {...props} />
))(({ theme }) => ({
  flexShrink: 0,
  zIndex: theme.zIndex.drawer + 1,
  [`& .MuiDrawer-paper`]: {
    width: 375,
    boxSizing: 'border-box',
    overflow: 'hidden',
  },
  [theme.breakpoints.down('mobile')]: {
    width: '100%',
    [`& .MuiDrawer-paper`]: {
      width: '100%',
    },
  },
}));

const SlidePaper = styled(Paper)({
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  overflowY: 'auto',
  position: 'absolute',
  top: 0,
  zIndex: 2,
  elevation: 0,
  square: true,
});
